export const coverThemeNames = {
  Daurat: 'gold',
  Gris: 'gray',
  'Gris fosc': 'grayDark',
  Marró: 'brown',
}
